import React, { useState, FunctionComponent, useEffect } from "react";
import {
  Typography,
  Grid,
  Paper,
  TextField,
  Button,
  CircularProgress,
  Fab,
  Tooltip,
} from "@material-ui/core";
import { styled } from "@mui/material/styles";
import { Formik, Form } from "formik";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useStore } from "../../../store/index";
import { api } from "../../../api";
import { Select } from "../../Select";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import { BarcodeDialog } from "../ItemReturnDialogs/BarcodeDialog";
//import { SnackBar } from "../../SnackBar";
import DirectionSnackbar from "../../SnackBar1";
import { WithBillDetails } from "./WithBillDetails";
import { ItemCategoryDialog } from "../ItemReturnDialogs/ItemCategoryDialog";
import RemoveIcon from "@material-ui/icons/DeleteForever";
import { CartonConfirmationDialog } from "../ItemReturnDialogs/CartonConfirmationDialog";
import { useItemReturnStyles } from "../useItemReturnStyles";
import Alert from "@mui/material/Alert";

type formValues = {
  item_number: string;
  quantity: string;
  foc_quantity: string;
  item_reason: string;
};

type rowType = {
  id: number;
  item_name: string;
  item_number: string;
  item_reason: number;
  plucode: string;
  quantity: string;
  foc_qty: string;
  unit_price: number;
  uom_max_loose: string;
  uom_name: string;
};

interface PropsTypes {
  customer_type: string;
  resetCustomer: () => void;
}
const CustomAlert = styled(Alert)`
  width: 300px;
  height: 50px;
  background-color: "#fdf3cc";
`;

export const WithBillPage: FunctionComponent<PropsTypes> = ({
  customer_type,
  resetCustomer,
}) => {
  const classes = useItemReturnStyles();
  const [rows, setRows] = useState<Array<rowType>>([]);
  const [displayTableData, setDisplayTableData] = useState<boolean>(false);
  const [billNumber, setBillNumber] = useState<string>("");
  const [returnType, setReturnType] = useState<string>("");
  const [displayItemDetails, setDisplayItemDetails] = useState<boolean>(false);
  const [displayItemForm, setDisplayItemForm] = useState<boolean>(false);
  const [itemDetails, setItemDetails] = useState<any>([]);
  const [duplicateItemDetails, setDuplicateItemDetails] = useState<
    Array<object>
  >([]);
  const [reasons] = useStore("reasons");
  const [barcodeValue, setBarcodeValue] = useState<string>("");
  const [openBarcodeDialog, setOpenBarcodeDialog] = useState<boolean>(false);
  const [returnOrExchange, setReturnOrExchange] = useState<string>("");
  const [quantityErrorFlag, setQuantityErrorFlag] = useState<boolean>(false);
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [totalQuantity, setTotalQuantity] = useState<number>(0);
  const [totalFocQuantity, setTotalFocQuantity] = useState<number>(0);
  const [itemReturnDays, setItemReturnDays] = useState<string>("");
  const [returnTypeError, setReturnTypeError] = useState<boolean>(false);
  const [invalidBillNumber, setInvalidBillNumber] = useState<boolean>(false);
  const [invalidPluNumber, setInvalidPluNumber] = useState<boolean>(false);
  const [validationError, setValidationError] = useState<boolean>(false);
  const [returnId, setReturnId] = useState<number>(0);
  const [validationErrorMessage, setValidationErrorMessage] = useState<string>(
    ""
  );
  const [isBillNoLoading, setIsBillNoLoading] = useState<boolean>(false);
  const [itemAddingArray, setItemAddingArray] = useState<Array<object>>([]);
  const [color, setColor] = useState<string>("#d50000");
  const [itemAddingLoading, setItemAddingLoading] = useState<boolean>(false);
  const [itemReturnLoading, setItemReturnLoading] = useState<boolean>(false);
  const [
    barcodeCancelConfirmationDialog,
    setBarcodeCancelConfirmationDialog,
  ] = useState<boolean>(false);
  const [openConfirmation, setOpenConfirmation] = useState<boolean>(false);
  const [openCategoryDialog, setOpenCategoryDialog] = useState<boolean>(false);
  const [piecesData, setPiecesData] = useState<any>([]);
  const [cartonData, setCartonData] = useState<any>([]);
  const [formValues, setFormValues] = useState<any>([]);
  const [cartonFlag, setCartonFlag] = useState<boolean>(false);
  const [selectedCarton, setSelectedCarton] = useState<string>("");
  const [productDetails, setProductDetails] = useState<any>([]);
  //const [uomId, setUomId] = useState<string>("");
  const [piecesCartonFlag, setPiecesCartonFlag] = useState<boolean>(false);
  const [weighingItemFlag, setWeighingItemFlag] = useState<boolean>(false);
  //const [open, setOpen] = useState(true);
  const [productNames, setProductNames] = useState<any>([]);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertPromo, setAlertPromo] = useState<string>("");
  const [alertVoucher, setAlertVoucher] = useState<string>("");

  const reasonOptions =
    reasons &&
    reasons.map((reason: { [key: string]: any }) => ({
      value: reason.reason_id,
      label: reason.reason_description,
    }));

  const billNumberValidation = (bill_number: string) => {
    setShowAlert(false);
    setPiecesCartonFlag(false);
    setDisplayItemDetails(false);
    setDisplayItemForm(false);
    setDisplayTableData(false);
    setRows([]);
    setTotalPrice(0);
    setItemAddingArray([]);
    const spaceValidation = /\s/;
    const numberValidation = /^[0-9]+$/;
    const isANumber = numberValidation.test(bill_number);
    if (bill_number !== "") {
      if (spaceValidation.test(bill_number)) {
        setValidationError(true);
        setInvalidBillNumber(true);
        setColor("#d50000");
        setValidationErrorMessage("White spaces are not allowed");
        setDisplayItemDetails(false);
        setDisplayItemForm(false);
      } else if (!isANumber) {
        setValidationError(true);
        setInvalidBillNumber(true);
        setColor("#d50000");
        setValidationErrorMessage("Only numbers are allowed");
        setDisplayItemDetails(false);
        setDisplayItemForm(false);
      } else {
        // if (bill_number.length === 17 || bill_number.length === 23) {
        setValidationError(false);
        setInvalidBillNumber(false);
        showItemList(bill_number, false);
        // } else {
        //   setValidationError(true);
        //   setInvalidBillNumber(true);
        //   setColor("#d50000");
        //   setValidationErrorMessage("Invalid Bill Number");
        //   setDisplayItemDetails(false);
        //   setDisplayItemForm(false);
        // }
      }
    } else {
      setValidationError(true);
      setInvalidBillNumber(true);
      setColor("#d50000");
      setValidationErrorMessage("Please enter a Bill Number");
    }
  };
  const showItemList = async (
    billNumber: string,

    inValid: boolean
  ) => {
    // billNumberValidation(billNumber);
    const invalidBillNumber = inValid;
    if (!invalidBillNumber) {
      try {
        setIsBillNoLoading(true);
        const itemDetail = await api.get(`bills/${billNumber}/item-return`);
        if (itemDetail.length === 0) {
          setDisplayItemDetails(false);
          setDisplayItemForm(false);
          setValidationError(true);
          setValidationErrorMessage("No details for the given bill number");
          setInvalidBillNumber(true);
          setIsBillNoLoading(false);
        } else {
          const alertDetail = await api.get(
            `bills/${billNumber}/checkpromovouch`
          );
          if (alertDetail.status === true) {
            setShowAlert(true);
            setAlertPromo(alertDetail?.data?.[0]?.promo_name);
            setAlertVoucher(alertDetail?.data?.[0]?.voucher_code);
          } else {
            setShowAlert(false);
            setAlertPromo("");
            setAlertVoucher("");
          }
          //validate for credit customer
          if (customer_type === "R" && !itemDetail[0].customer_ref_no) {
            setDisplayItemDetails(false);
            setDisplayItemForm(false);
            setValidationError(true);
            setValidationErrorMessage(
              "Verification for credit customer failed"
            );
            setIsBillNoLoading(false);
            resetCustomer();
          } else {
            const { barcode } = await api.post(
              "item-return/initiate",
              {},
              { pay_mode: customer_type }
            );
            localStorage.setItem("item-ret-barcode", barcode);
            setDisplayItemDetails(true);
            setDisplayItemForm(true);
            setValidationError(false);
            setIsBillNoLoading(false);
          }
        }
        setItemDetails(itemDetail);
        const duplicateDetails =
          itemDetail && itemDetail.map((item: object) => ({ ...item }));
        setDuplicateItemDetails(duplicateDetails);
        // resetForm();
      } catch (error) {
        localStorage.removeItem("item-ret-barcode");
        console.log(error);
      }
    }
  };
  /* const onCloseSnackBar = () => {    
  setValidationErrorMessage("");
  };
 */
  const handleClose = () => {
    //setOpen(false);
    setValidationError(false);
  };

  useEffect(() => {
    //console.log(showAlert);
  }, [showAlert, alertPromo, alertVoucher]);

  const onItemAddingToReturnTable = async (
    values: formValues,
    resetForm: any
  ) => {
    try {
      // const pluNumberExisting =
      //   duplicateItemDetails &&
      //   duplicateItemDetails.filter(
      //     (item: any) => item.ref_plu === values.item_number
      //   );
      setItemAddingLoading(true);
      if (!values.quantity.match(/^[0-9]+$/)) {
        setValidationError(true);
        setColor("#d50000");
        setValidationErrorMessage("Decimal points are not allowed");
        setItemAddingLoading(false);
      } else if (values.quantity === "0" && values.foc_quantity === "0") {
        setValidationError(true);
        setColor("#d50000");
        setValidationErrorMessage("Please give a quantity or Foc other than 0");
        setItemAddingLoading(false);
      } else if (values.quantity !== "0" && values.foc_quantity !== "0") {
        setValidationError(true);
        setColor("#d50000");
        setValidationErrorMessage("Please enter quantity and Foc seperately");
        setItemAddingLoading(false);
      } else if (values.item_reason === "") {
        /*  else if (values.quantity === "0") {
        if(values.foc_quantity==="0"){
        setValidationError(true);
        setColor("#d50000");
        setValidationErrorMessage("Please give a quantity or foc quantity other than 0");
        setItemAddingLoading(false);
        }
      }  */
        setValidationError(true);
        setColor("#d50000");
        setValidationErrorMessage("Please select a reason to return product");
        setItemAddingLoading(false);
      }

      // else if (pluNumberExisting.length === 0) {
      //   setValidationError(true);
      //   setColor("#d50000");
      //   setValidationErrorMessage("Please enter a valid item number");
      //   setItemAddingLoading(false);
      //   resetForm();
      // }
      else {
        const data = { bill_doc_number: itemDetails[0].bill_doc_number };

        const result = await api.get(`products/${values.item_number}`, data);
        setProductDetails(result);
        const filteredItemDetails = itemDetails.filter(
          (i: any) => i.item_code === result.item_code
        );
        const piecesArray = filteredItemDetails.filter(
          (i: any) => i.uom_name === "EACH"
        );
        const cartonArray = filteredItemDetails.filter(
          (i: any) => i.uom_name.substring(0, 6) === "Carton"
        );
        setPiecesData(piecesArray);
        setCartonData(cartonArray);
        setFormValues(values);

        if (cartonArray.length !== 0 && piecesArray.length === 0) {
          /* Carton only condition */
          if (
            cartonArray.find((i: any) => i.ref_plu === values.item_number) !==
            undefined
          ) {
            /* return the whole carton */
            setItemAddingLoading(true);
            setPiecesCartonFlag(false);
            const cartonCode = true;
            itemAddingCartonSubmit(values, resetForm, cartonCode);
            setValidationError(false);
            setValidationErrorMessage("");
          } else {
            /* return an item from the carton */
            const findPlucode = result.plucodes.find(
              (i: any) => i === values.item_number
            );
            if (findPlucode !== undefined) {
              setPiecesCartonFlag(true);
              if (cartonArray.length === 1) {
                setCartonFlag(true);
                setOpenConfirmation(true);
                setItemAddingLoading(false);
              } else {
                setCartonFlag(false);
                setOpenConfirmation(true);
                setItemAddingLoading(false);
              }
            } else {
              setItemAddingLoading(false);
              setValidationError(true);
              setColor("#d50000");
              setValidationErrorMessage("Invalid PLU Number");
            }
          }
        } else if (cartonArray.length !== 0 && piecesArray.length !== 0) {
          /* Carton and pieces included condition */
          setOpenCategoryDialog(true);
        } else {
          /* Condition for normal validation including simply pieces,kg items */
          if (
            itemDetails.find((i: any) => i.ref_plu === values.item_number) !==
            undefined
          ) {
            /* Check whether the scanned ref_plu is exist in the bill details */
            setItemAddingLoading(true);
            itemAddingSubmit(values, resetForm);
            setValidationError(false);
            setValidationErrorMessage("");
          } else {
            /* scanned ref_plu is not exist in the bill details */
            setItemAddingLoading(false);
            setValidationError(true);
            setColor("#d50000");
            setValidationErrorMessage("Invalid PLU Number");
          }
        }
      }
    } catch (error: any) {
      console.log(error);
      setValidationError(true);
      setColor("#d50000");
      setValidationErrorMessage(
        error.error === "Ïnvalid plucode"
          ? "Ïnvalid plucode"
          : "Something went wrong"
      );
      setItemAddingLoading(false);
    }
  };

  const itemAddingSubmit = async (values: any, resetForm: any) => {
    setBarcodeCancelConfirmationDialog(false);
    const pluNumberExisting =
      duplicateItemDetails &&
      duplicateItemDetails.filter(
        (item: any) => item.ref_plu === values.item_number
      );
    if (pluNumberExisting.length !== 0) {
      let getQuantity: any =
        duplicateItemDetails &&
        duplicateItemDetails.find(
          (item: any) => item.ref_plu === values.item_number
        );
      //setUomId(getQuantity.uom_id);
      if (getQuantity !== undefined) {
        const result =
          parseFloat(getQuantity.total_quantity) - parseFloat(values.quantity);
        const totalQty = totalQuantity + parseFloat(values.quantity);
        const totalFocQty = totalFocQuantity + parseFloat(values.foc_quantity);
        try {
          const filteredData =
            rows.length !== 0
              ? rows.filter((i: any) => i.item_number === values.item_number)
              : [];
          let addedQuantity = 0;
          let addedFocQuantity = 0;

          filteredData.forEach((i: any) => {
            addedQuantity = addedQuantity + parseFloat(i.quantity);
            addedFocQuantity = addedFocQuantity + parseFloat(i.foc_qty);
          });
          //setUomId(getQuantity.uom_id);
          const itemValidationObject = {
            bill_id: getQuantity.bill_id,
            terminal_id: getQuantity.terminal_id,
            store_id: getQuantity.store_id,
            quantity: addedQuantity, // input value
            currentQuantity: values.quantity,
            ref_plu: values.item_number,
            plucode: getQuantity.plucode,
            reason_id: values.item_reason.value,
            item_name: getQuantity.item_name,
            bill_date: getQuantity.bill_date,
            uom_max_loose: getQuantity.uom_max_loose,
            with_bill: true,
            uom_id: getQuantity.uom_id,
            pdct_uom_code: getQuantity.pdct_uom_code,
            billdocnumber: getQuantity.bill_doc_number,
            foc_qty: addedFocQuantity, //getQuantity.foc_qty,
            currentFocQuantity: values.foc_quantity,
            foc_loose: getQuantity.foc_loose,
            uom_name: getQuantity.uom_name,
          };
          const validationResult = await api.post(
            `item-return-validation`,
            {},
            itemValidationObject
          );
          if (validationResult.Status === "True") {
            const exactQuantity =
              validationResult.is_weighing_item === true
                ? validationResult.currentQuantity
                : values.quantity;
            const itemValues = {
              id: validationResult.random_id,
              item_number: validationResult.ref_plu,
              plucode: validationResult.plucode,
              item_reason: validationResult.reason_id,
              quantity: validationResult.quantity,
              quantityEntered: exactQuantity,
              item_name: validationResult.item_name,
              uom_max_loose: validationResult.uom_max_loose,
              unit_price: validationResult.unit_price,
              foc_qty: validationResult.currentFocQuantity,
              focquantityEntered: values.foc_quantity,
              foc_loose: validationResult.foc_loose,
              is_weighing_item: validationResult.is_weighing_item,
              uom_id: validationResult.uom_id,
              uom_name: validationResult.uom_name,
            };
            const price =
              parseFloat(validationResult.unit_price) *
                parseFloat(exactQuantity) +
              totalPrice;
            setTotalQuantity(totalQty);
            setTotalFocQuantity(totalFocQty);
            setQuantityErrorFlag(false);
            setRows([]);
            updateData(itemValues);
            setDisplayTableData(true);
            resetForm();
            getQuantity.total_quantity = result;
            ///const newArray = [getQuantity];
            /* var res = duplicateItemDetails.map(
              (duplicateItem: any) =>
                newArray.find(
                  (obj: any) => obj.ref_plu === duplicateItem.ref_plu
                ) || duplicateItem
            ); */

            setTotalPrice(price);
            setValidationError(false);
          } else {
            setValidationError(true);
            setColor("#d50000");
            setValidationErrorMessage(validationResult.Comment);
            resetForm();
          }
        } catch (error: any) {
          console.log(error);
          setValidationError(true);
          setColor("#d50000");
          setValidationErrorMessage(
            error.error === "Invalid plucode"
              ? "Invalid plucode"
              : "Something went wrong"
          );
        }
        setInvalidPluNumber(false);
      }
    } else {
      setValidationError(true);
      setColor("#d50000");
      setValidationErrorMessage("Invalid Plu  Number");
    }
    setItemAddingLoading(false);
  };

  const itemAddingCartonSubmit = async (
    values: any,
    resetForm: any,
    cartonCode: boolean
  ) => {
    setBarcodeCancelConfirmationDialog(false);

    let getQuantity: any =
      cartonCode === true
        ? duplicateItemDetails &&
          duplicateItemDetails.find(
            (item: any) => item.ref_plu === values.item_number
          )
        : cartonData.length > 1
        ? duplicateItemDetails &&
          duplicateItemDetails.find(
            (item: any) =>
              item.item_code === productDetails.item_code &&
              item.pdct_uom_code === selectedCarton
          )
        : cartonFlag === true
        ? duplicateItemDetails &&
          duplicateItemDetails.find(
            (item: any) =>
              item.item_code === productDetails.item_code &&
              item.uom_name.slice(0, 6) === "Carton"
          )
        : duplicateItemDetails &&
          duplicateItemDetails.find(
            (item: any) =>
              item.item_code === productDetails.item_code &&
              item.uom_name === "EACH"
          );
    if (getQuantity !== undefined) {
      /* const result =
        parseFloat(getQuantity.total_quantity) - parseFloat(values.quantity); */
      const totalQty = totalQuantity + parseFloat(values.quantity);
      const totalFocQty = totalFocQuantity + parseFloat(values.foc_quantity);
      try {
        const itemValues = [...itemAddingArray, values];
        /* const formFilter =
          itemValues &&
          itemValues.filter(
            (item: any) => item.item_number === values.item_number
          ); */
        setItemAddingArray(itemValues);
        /* const quantityArray =
          formFilter &&
          formFilter.map((item: any) => parseFloat(item.quantity));

          const focQuantityArray =
          formFilter.map((item: any) => parseFloat(item.foc_qty));  */

        //const reducer = (accumulator: any, currentValue: any) =>
        // accumulator + currentValue;
        //const totalQuantity = quantityArray.reduce(reducer);
        //const totalFocQuantity = focQuantityArray.reduce(reducer);

        const filteredList =
          rows.length !== 0
            ? rows.filter((i: any) => i.item_code === productDetails.item_code)
            : [];
        const itemValidationObject = {
          bill_id: getQuantity.bill_id,
          terminal_id: getQuantity.terminal_id,
          store_id: getQuantity.store_id,
          quantity: values.quantity,
          item_list: filteredList,
          total_quantity: getQuantity.total_quantity,
          ref_plu: getQuantity.plucode,
          plucode: values.item_number,
          reason_id: values.item_reason.value,
          item_name: getQuantity.item_name,
          bill_date: getQuantity.bill_date,
          uom_max_loose: getQuantity.uom_max_loose,
          with_bill: true,
          total_price: getQuantity.total_price,
          uom_id: getQuantity.uom_id,
          pdct_uom_code: getQuantity.pdct_uom_code,
          ret_item_uom_type:
            piecesCartonFlag === true ? "PCS" : getQuantity.pdct_uom_code,
          foc_qty: values.foc_quantity,
          totalFocQuantity: getQuantity.foc_qty,
          foc_loose: getQuantity.foc_loose,
          uom_name: getQuantity.uom_name,
          item_code: getQuantity.item_code,
        };
        //setUomId(getQuantity.uom_id);
        setPiecesCartonFlag(false);
        const validationResult = await api.post(
          `item-return-validation/carton`,
          {},
          itemValidationObject
        );

        if (validationResult.Status === "True") {
          const itemValues = {
            id: validationResult.random_id,
            item_number: validationResult.ref_plu,
            plucode: validationResult.plucode,
            item_reason: validationResult.reason_id,
            quantity: validationResult.quantity,
            quantityEntered: values.quantity,
            item_name: validationResult.item_name,
            uom_max_loose: validationResult.uom_max_loose,
            unit_price: validationResult.unit_price,
            foc_qty: validationResult.foc_qty,
            focquantityEntered: values.foc_quantity,
            foc_loose: validationResult.foc_loose,
            uom_id: validationResult.uom_id,
            uom_name: validationResult.uom_name,
            ret_item_uom_type: validationResult.ret_item_uom_type,
            item_code: validationResult.item_code,
          };
          const price =
            parseFloat(validationResult.unit_price) *
              parseFloat(values.quantity) +
            totalPrice;

          setTotalQuantity(totalQty);
          setTotalFocQuantity(totalFocQty);
          setQuantityErrorFlag(false);
          setRows([]);
          updateData(itemValues);
          setDisplayTableData(true);
          resetForm();
          // getQuantity.total_quantity = result;
          ////const newArray = [getQuantity];
          setTotalPrice(price);
          setValidationError(false);
          setOpenConfirmation(false);
        } else {
          setValidationError(true);
          setColor("#d50000");
          setValidationErrorMessage(validationResult.Comment);
          itemValues.pop();
          resetForm();
          setPiecesCartonFlag(false);
          setOpenConfirmation(false);
        }
      } catch (error: any) {
        console.log(error);
        setValidationError(true);
        setColor("#d50000");
        setValidationErrorMessage(
          error.error === "Invalid plucode"
            ? "Invalid plucode"
            : "Something went wrong"
        );
      }
      setInvalidPluNumber(false);
    }
    setItemAddingLoading(false);
    setOpenConfirmation(false);
  };

  const updateData = (newItemDetails: any) => {
    //newItemDetails.item_reason = newItemDetails.item_reason;
    if (rows !== undefined) {
      const duplicateRowDetails = rows && rows.map((row: any) => ({ ...row }));
      const overlappedRow =
        duplicateRowDetails &&
        duplicateRowDetails.find(
          (row: any) =>
            row.item_number === newItemDetails.item_number &&
            row.item_reason === newItemDetails.item_reason &&
            row.plucode === newItemDetails.plucode &&
            row.uom_name === newItemDetails.uom_name
        );
      if (overlappedRow) {
        overlappedRow.quantity = (
          parseFloat(overlappedRow.quantity) +
          parseFloat(newItemDetails.quantityEntered)
        ).toFixed(3);
        overlappedRow.foc_qty = (
          parseFloat(overlappedRow.foc_qty) +
          parseFloat(newItemDetails.focquantityEntered)
        ).toFixed(3);
        const nonoverlaped = rows.filter(
          (it: any) =>
            it.item_number !== overlappedRow.item_number ||
            it.item_reason !== overlappedRow.item_reason ||
            it.plucode !== overlappedRow.plucode ||
            it.uom_name !== overlappedRow.uom_name
        );
        const newArray = [overlappedRow, ...nonoverlaped];
        setRows(newArray);
        if (newItemDetails.is_weighing_item === true) {
          setWeighingItemFlag(true);
        } else {
          setWeighingItemFlag(false);
        }
      } else {
        newItemDetails.quantity = parseFloat(
          newItemDetails.quantityEntered
        ).toFixed(3);
        newItemDetails.foc_qty = parseFloat(
          newItemDetails.focquantityEntered
        ).toFixed(3);
        const newArray = [...rows, newItemDetails];
        setRows(newArray);
        if (newItemDetails.is_weighing_item === true) {
          setWeighingItemFlag(true);
        } else {
          setWeighingItemFlag(false);
        }
      }
    } else {
      setRows([newItemDetails]);
      if (newItemDetails.is_weighing_item === true) {
        setWeighingItemFlag(true);
      } else {
        setWeighingItemFlag(false);
      }
    }
    setOpenConfirmation(false);
    // rows.push(newItemData)
  };
  const onKeyDown = (keyEvent: any) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  };

  const submitConfirmation = (resetForm: any) => {
    const cartonCode = false;
    itemAddingCartonSubmit(formValues, resetForm, cartonCode);
  };

  const updateSelectedCarton = (value: string) => {
    setSelectedCarton(value);
  };

  const closeCartonDialog = () => {
    setOpenConfirmation(false);
  };

  const updateCategory = (name: any, resetForm: any) => {
    if (name === "pieces") {
      /* Pieces only condition */

      if (
        piecesData.find((i: any) => i.ref_plu === formValues.item_number) !==
        undefined
      ) {
        setItemAddingLoading(true);
        itemAddingSubmit(formValues, resetForm);
        setValidationError(false);
        setValidationErrorMessage("");
      } else {
        setItemAddingLoading(false);
        setValidationError(true);
        setColor("#d50000");
        setValidationErrorMessage("Invalid PLU Number");
      }
    } else {
      /* Carton only condition */

      if (
        cartonData.find((i: any) => i.ref_plu === formValues.item_number) !==
        undefined
      ) {
        setItemAddingLoading(true);
        setPiecesCartonFlag(false);
        const cartonCode = true; //false;
        itemAddingCartonSubmit(formValues, resetForm, cartonCode);
        setValidationError(false);
        setValidationErrorMessage("");
      } else {
        setPiecesCartonFlag(true);
        if (cartonData.length === 1) {
          setCartonFlag(true);
          setOpenConfirmation(true);
          setItemAddingLoading(false);
        } else {
          setCartonFlag(false);
          setOpenConfirmation(true);
          setItemAddingLoading(false);
        }
      }
    }
    setOpenCategoryDialog(false);
  };

  const closeCategoryDialog = () => {
    setOpenCategoryDialog(false);
  };
  const sendItemDetails = async (items: any, return_type: string) => {
    try {
      if (return_type == "return") {
        setReturnType("return");
        if (totalPrice > 0) {
          setItemReturnLoading(true);
          const findResults = items.map((item: any) => ({
            //   bill_id: itemDetails.find(
            //     (item1: any) => item1.ref_plu === item.item_number
            //   ).bill_id,
            bill_id: itemDetails[0].bill_id,
            terminal_id: itemDetails[0].terminal_id,
            // itemDetails.find(
            //   (item1: any) => item1.ref_plu === item.item_number
            // ).terminal_id,
            store_id: itemDetails[0].store_id,
            // itemDetails.find(
            //   (item1: any) => item1.ref_plu === item.item_number
            // ).store_id,
            quantity: item.quantity.toString(),
            //parseFloat(item.quantity.toString()) *
            amount: item.unit_price,
            item_ret_type: return_type,
            reason_id: item.item_reason,
            ref_plu: item.item_number,
            plu_code: item.plucode,
            uom_max_loose: item.uom_max_loose,
            uom_id: item.uom_id,
            ret_item_uom_type: item.ret_item_uom_type, //piecesCartonFlag === true ? "PCS" : uomCode,
            foc_qty: item.foc_qty.toString(),
            foc_loose: item.foc_loose,
          }));
          const finalObjectToPass = {
            total_amount: totalPrice,
            pay_mode: customer_type,
            item_return_details: findResults,
            item_return_barcode: localStorage.getItem("item-ret-barcode"),
          };
          const createdItemReturn = await api.post(
            `item-return`,
            {},
            finalObjectToPass
          );
          setReturnId(createdItemReturn.item_return_id);
          setBarcodeValue(createdItemReturn.bar_code);
          setItemReturnDays(createdItemReturn.return_days);
          setOpenBarcodeDialog(true);
          setReturnTypeError(false);
          setItemReturnLoading(false);
          setPiecesCartonFlag(false);
        } else {
          setValidationError(true);
          setColor("#d50000");
          setValidationErrorMessage("Total Amount should be greater than 0");
        }
      } else if (return_type === "exchange") {
        setReturnType("exchange");
        if (totalPrice > 0) {
          setItemReturnLoading(true);
          const findResults = items.map((item: any) => ({
            bill_id: itemDetails[0].bill_id,
            terminal_id: itemDetails[0].terminal_id,
            store_id: itemDetails[0].store_id,
            quantity: item.quantity.toString(),
            amount: item.unit_price,
            item_ret_type: return_type,
            reason_id: item.item_reason,
            ref_plu: item.item_number,
            plu_code: item.plucode,
            uom_max_loose: item.uom_max_loose,
            uom_id: item.uom_id,
            ret_item_uom_type: item.ret_item_uom_type,
            foc_qty: item.foc_qty.toString(),
            foc_loose: item.foc_loose,
            item_name: item.item_name,
          }));
          const finalObjectToPass = {
            total_amount: totalPrice,
            pay_mode: customer_type,
            item_exchange_details: findResults,
            item_exchange_barcode: localStorage.getItem("item-ret-barcode"),
          };
          const createdItemExchange = await api.post(
            `item-return/exchange`,
            {},
            finalObjectToPass
          );
          setReturnId(createdItemExchange.item_exchange_id);
          setBarcodeValue(createdItemExchange.bar_code);
          setItemReturnDays(createdItemExchange.exchange_days);
          console.log(
            "item_product_details",
            createdItemExchange.item_product_details
          );
          setProductNames(createdItemExchange.item_product_details);
          setOpenBarcodeDialog(true);
          setReturnTypeError(false);
          setItemReturnLoading(false);
          setPiecesCartonFlag(false);
        } else {
          setValidationError(true);
          setColor("#d50000");
          setValidationErrorMessage("Total Amount should be greater than 0");
        }
      } else {
        setItemReturnLoading(false);
        setReturnTypeError(true);
        setPiecesCartonFlag(false);
      }
    } catch (e: any) {
      console.log(e);
      setItemReturnLoading(false);
      setPiecesCartonFlag(false);
      setDisplayTableData(false);
      setRows([]);
      setValidationError(true);
      setColor("#d50000");
      setValidationErrorMessage(e.error);
    }
  };

  const handleCloseBarcodeDialogDisAgree = () => {
    setBarcodeCancelConfirmationDialog(false);
    // setOpenBarcodeDialog(false)
  };
  const handleCloseBarcodeDialog = async () => {
    setBarcodeCancelConfirmationDialog(true);
  };
  const handleCloseBarcodeDialogAgree = async () => {
    const itemReturnResult = await api.patch(
      `item-return/cancelItemReturn/${returnId}`,
      {},
      {}
    );
    if (itemReturnResult) {
      setColor("#33691e");
      setValidationError(true);
      setValidationErrorMessage("item return cancelled successfully");
    } else {
      setValidationError(false);
    }
    setOpenBarcodeDialog(false);
  };
  const clearDataAfterPrint = () => {
    setOpenBarcodeDialog(false);
    setDisplayItemDetails(false);
    setDisplayItemForm(false);
    setDisplayTableData(false);
    setBillNumber("");
    setRows([]);
    setTotalPrice(0);
    setTotalFocQuantity(0);
    setItemAddingArray([]);
    localStorage.removeItem("item-ret-barcode");
    resetCustomer();
  };
  const clearBillNumber = () => {
    setBillNumber("");
    setDisplayItemDetails(false);
    setDisplayItemForm(false);
    setReturnTypeError(false);
    setValidationError(false);
    setValidationErrorMessage("");
    localStorage.removeItem("item-ret-barcode");
  };
  const cancelItemFromReturnTable = (id: number) => {
    const deletedItem = rows && rows.find((row: rowType) => row.id === id);
    // console.log("deletedItem",deletedItem)
    const deleteAnItem = rows && rows.filter((row: rowType) => row.id !== id);
    if (deletedItem !== undefined) {
      const reducePriceOfDeletedItem =
        totalPrice - parseFloat(deletedItem.quantity) * deletedItem.unit_price;
      // console.log("reducePriceOfDeletedItem",reducePriceOfDeletedItem )
      setTotalPrice(reducePriceOfDeletedItem);
    }

    setRows(deleteAnItem);
  };
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {/* <form> */}
        <Grid container direction="row" alignItems="center">
          <Grid item xs={12} sm={6}>
            <Grid container direction="column">
              <Typography style={{ textAlign: "left" }}>
                Enter your Bill Number<span style={{ color: "red" }}> * </span>
              </Typography>
              <TextField
                variant="outlined"
                name="bill_number"
                onChange={(event: any) => setBillNumber(event.target.value)}
                required={true}
                value={billNumber}
              />
            </Grid>
          </Grid>
          <Grid item xs={10} sm={2} className={classes.itemDetailsButton}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => billNumberValidation(billNumber)}
              type="submit"
              disabled={isBillNoLoading}
            >
              Show Item Details
            </Button>
            {isBillNoLoading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </Grid>
          <Grid item xs={6} sm={2} className={classes.clearButton}>
            <Button
              variant="contained"
              color="primary"
              onClick={clearBillNumber}
              // type="submit"
              // disabled={isLoading}
            >
              Clear
            </Button>
          </Grid>
          <Grid>

          {showAlert && (
            <Grid
              item
              style={{ display:  showAlert?"flex":"none", flexDirection: "column" }}
              xs={12}
            >
              <Alert
                variant="standard"
                severity="warning"
                sx={{
                  background: "#fdf3cc",
                  borderRadius: "15px",
                  mt: 1,
                  height: "30px",                             
                  minwidth:"300px",                               
                  "& .MuiAlert-icon": {
                    padding: 0,
                    fontSize: "20px",
                    color: "#c09600",
                    borderRadius: 1,
                  },
                  "& .MuiAlert-message": {
                    padding: 0,
                    //width:"100%",  
                    fontSize: "15px",
                    color: "#c09600",
                    overflow: "inherit",
                  },
                }}
              >
                {alertPromo}
              </Alert>
            </Grid>
          )}
          {showAlert && (
            <Grid
              item
              style={{ display:  showAlert?"flex":"none", flexDirection: "row" }}
              xs={12}
            >
              <Alert
                variant="standard"
                severity="warning"
                
                sx={{
                  background: "#fdf3cc",
                  borderRadius: "15px",
                  mt: 1,
                  height: "30px",                 
                  "& .MuiAlert-icon": {
                    padding: 0,
                    fontSize: "20px",
                    color: "#c09600",
                    borderRadius: 1,
                  },
                  "& .MuiAlert-message": {
                    padding: 0,
                     width:"100%",  
                    fontSize: "15px",
                    color: "#c09600",
                    overflow: "inherit",
                  },
                }}
              >
                {alertVoucher}
              </Alert>
            </Grid>
          )}
          </Grid>
          <Grid
            item
            xs={6}
            style={{ display: displayItemDetails ? "" : "none" }}
          ></Grid>
          <Grid
            item
            xs={12}
            style={{ display: displayItemDetails ? "" : "none" }}
          >
            <Typography
              style={{
                fontSize: "1.1rem",
                fontWeight: "bold",
                color: "#000",
                display: displayItemDetails ? "" : "none",
                textAlign: "right",
              }}
            >
              Total : QR {totalPrice.toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
        {/* </form> */}
      </Grid>
      <Grid item xs={12} sm={12}>
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            md={4}
            style={{ display: displayItemDetails ? "" : "none" }}
          >
            <WithBillDetails
              itemDetails={itemDetails}
              invalidBillNumber={invalidBillNumber}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={8}
            style={{ display: displayItemForm ? "" : "none" }}
          >
            <Paper
              className={classes.paper}
              elevation={4}
              style={{ minHeight: "25em", overflowX: "auto" }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Formik
                    enableReinitialize
                    initialValues={{
                      item_number: "",
                      item_reason: "",
                      quantity: "",
                      foc_quantity: "0",
                    }}
                    onSubmit={(values, { resetForm }) => {
                      onItemAddingToReturnTable(values, resetForm);
                    }}
                  >
                    {({ values, handleChange, setFieldValue, resetForm }) => (
                      <Form>
                        <Grid container spacing={3}>
                          <Grid item xs={3}>
                            <Grid container direction="column">
                              <Typography style={{ textAlign: "left" }}>
                                Item No.
                              </Typography>
                              <TextField
                                variant="outlined"
                                name="item_number"
                                onChange={handleChange}
                                value={values.item_number}
                                required
                                error={invalidPluNumber}
                                helperText={
                                  invalidPluNumber ? "Invalid Plu Number" : ""
                                }
                                // onKeyDown={onKeyDown}
                              />
                            </Grid>
                          </Grid>
                          <Grid item xs={2}>
                            <Grid container direction="column">
                              <Typography style={{ textAlign: "left" }}>
                                Quantity
                              </Typography>
                              <TextField
                                variant="outlined"
                                name="quantity"
                                onChange={handleChange}
                                value={values.quantity}
                                error={quantityErrorFlag}
                                helperText={
                                  quantityErrorFlag
                                    ? "entered quantity must be less than or equal to the original one"
                                    : ""
                                }
                                required
                                onKeyDown={onKeyDown}
                              />
                            </Grid>
                          </Grid>
                          <Grid item xs={2}>
                            <Grid container direction="column">
                              <Typography style={{ textAlign: "left" }}>
                                Foc
                              </Typography>
                              <TextField
                                variant="outlined"
                                name="foc_quantity"
                                onChange={handleChange}
                                value={values.foc_quantity}
                                //required
                                onKeyDown={onKeyDown}
                              />
                            </Grid>
                          </Grid>
                          <Grid item xs={3}>
                            <Grid container direction="column">
                              <Typography style={{ textAlign: "left" }}>
                                Reason
                              </Typography>
                              <Select
                                required
                                options={reasonOptions}
                                style={{ height: "2em" }}
                                value={values.item_reason}
                                onChange={(value: any) => {
                                  setFieldValue("item_reason", value);
                                }}
                                // onKeyDown={onKeyDown}
                              ></Select>
                            </Grid>
                          </Grid>

                          <Grid
                            item
                            xs={2}
                            style={{ textAlign: "center", marginTop: "2.5em" }}
                          >
                            <Button
                              variant="contained"
                              color="primary"
                              type="submit"
                              disabled={itemAddingLoading}
                            >
                              submit
                            </Button>
                            {itemAddingLoading && (
                              <CircularProgress
                                size={24}
                                className={classes.buttonItemAddProgress}
                              />
                            )}
                          </Grid>
                        </Grid>
                        {openCategoryDialog === true ? (
                          <ItemCategoryDialog
                            openCategoryDialog={openCategoryDialog}
                            closeCategoryDialog={closeCategoryDialog}
                            updateCategory={updateCategory}
                            resetForm={resetForm}
                          />
                        ) : null}
                        {openConfirmation === true ? (
                          <CartonConfirmationDialog
                            openConfirmation={openConfirmation}
                            cartonFlag={cartonFlag}
                            cartonData={cartonData}
                            closeCartonDialog={closeCartonDialog}
                            updateSelectedCarton={updateSelectedCarton}
                            submitConfirmation={submitConfirmation}
                            resetForm={resetForm}
                          />
                        ) : null}
                      </Form>
                    )}
                  </Formik>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ display: displayTableData ? "" : "none" }}
                >
                  <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center"> Item Name</TableCell>
                        <TableCell align="center"> Item Number</TableCell>
                        <TableCell align="center"> Reason</TableCell>
                        <TableCell align="center"> Quantity</TableCell>
                        <TableCell align="center"> Foc</TableCell>
                        <TableCell align="center">Price</TableCell>
                        <TableCell align="center">Type</TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows &&
                        rows.map((row: rowType) => (
                          <TableRow key={row.item_number}>
                            <TableCell align="center">
                              {row.item_name}
                            </TableCell>
                            <TableCell align="center">
                              {row.uom_name === "EACH"
                                ? row.item_number
                                : row.uom_name === "KG"
                                ? row.item_number
                                : row.plucode}
                            </TableCell>
                            <TableCell align="center">
                              {
                                reasonOptions.find(
                                  (reason: any) =>
                                    reason.value === row.item_reason
                                ).label
                              }
                            </TableCell>
                            <TableCell align="center">{row.quantity}</TableCell>
                            <TableCell align="center">{row.foc_qty}</TableCell>
                            <TableCell align="center">
                              {row.unit_price}
                            </TableCell>
                            <TableCell align="center">{row.uom_name}</TableCell>
                            <TableCell align="center">
                              <Tooltip title="Remove">
                                <Fab
                                  size="small"
                                  color="primary"
                                  aria-label="delete"
                                >
                                  <RemoveIcon
                                    onClick={() =>
                                      cancelItemFromReturnTable(row.id)
                                    }
                                  />
                                </Fab>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                  <Grid item xs={12}>
                    <RadioGroup
                      aria-label="position"
                      row
                      name="item_return"
                      onChange={(event: any) => {
                        setReturnOrExchange(event.target.value);
                      }}
                      value={returnOrExchange}
                    >
                      <FormControlLabel
                        value="return"
                        control={<Radio color="primary" />}
                        label="Return"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="exchange"
                        control={<Radio color="primary" />}
                        label="Exchange"
                        labelPlacement="end"
                      />
                    </RadioGroup>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{ display: returnTypeError ? "flex" : "none" }}
                  >
                    <Typography style={{ color: "red", fontSize: "0.875rem" }}>
                      please select return type...
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => sendItemDetails(rows, returnOrExchange)}
                      disabled={itemReturnLoading}
                    >
                      Item Return
                    </Button>
                    {itemReturnLoading && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonItemReturnProgress}
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      {openBarcodeDialog ? (
        <BarcodeDialog
          openBarcodeDialog={openBarcodeDialog}
          barcodeValue={barcodeValue}
          type={returnType}
          printDetails={productNames}
          rePrint={false}
          handleCloseBarcodeDialog={handleCloseBarcodeDialog}
          totalPrice={totalPrice}
          itemReturnDays={itemReturnDays}
          clearDataAfterPrint={clearDataAfterPrint}
          barcodeCancelConfirmationDialog={barcodeCancelConfirmationDialog}
          handleCloseBarcodeDialogAgree={handleCloseBarcodeDialogAgree}
          handleCloseBarcodeDialogDisAgree={handleCloseBarcodeDialogDisAgree}
          isCreditCustomer={customer_type === "R" ? true : false}
          handleClose={clearDataAfterPrint}
        />
      ) : (
        ""
      )}

      {/* {validationError ? (
        <SnackBar
        open={open}
          onCloseError={handleClose}
          status={validationErrorMessage}
          color={color}
        />
      ) : (
        ""
      )} */}
      {validationError ? (
        <DirectionSnackbar
          open={validationError}
          onClose={handleClose}
          message={validationErrorMessage}
          color={color}
        />
      ) : (
        ""
      )}

      <Dialog
        open={weighingItemFlag}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            It's a weighing Item. So user input quantity will not be taken
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setWeighingItemFlag(false);
            }}
            autoFocus
            id="buton"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};
